import { Upload, type UploadProps } from "antd";
import clsx from "clsx";
import "./BUpload.scss";

const BUpload = ({ className, ...props }: UploadProps) => (
  <Upload className={clsx("b-upload", className)} {...props} />
);

export default BUpload;
